<footer class="site-footer" *ngIf="hideFooter">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-6 col-md-6 col-xs-8">
                <div class="footer-info">
                    <h3 class="mb-4">{{'footer.subscription' | translate}}</h3>
                    <p>{{'footer.subscribe' | translate}}</p>
                    <div class="mailchimp-form">
                        <form method="post" action="#0">
                            <div class="row">
                                <!-- <div class="col-lg-11 field-group mt-2 mb-3 d-flex">
                                <input class="email-input" type="email" name="EMAIL" id="email-input"
                                    [(ngModel)]="contact" placeholder="{{ 'footer.email' | translate }}" autocomplete="off">
                                <input  class="primary-btn" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px;" type="submit"
                                    [value]="'footer.subscribe-now' | translate" name="subscribe" (click)="subscribeBtn()">
                                </div> -->
                                <div class="col-lg-11 field-group mt-2 mb-3 d-flex flex-column">
                                    <div class="d-flex">
                                        <input class="email-input" type="email" name="EMAIL" id="email-input"
                                            [(ngModel)]="contact" placeholder="{{ 'footer.email' | translate }}"
                                            autocomplete="off">
                                        <input class="primary-btn"
                                            style="border-top-left-radius: 0px; border-bottom-left-radius: 0px;"
                                            type="submit" [value]="'footer.subscribe-now' | translate" name="subscribe"
                                            (click)="subscribeBtn()">
                                    </div>
                                    <div *ngIf="message.text" class="mt-1 d-flex align-items-center"
                                        [ngClass]="message.type">
                                        <i [ngClass]="message.icon" class="mr-3"></i>
                                        <span>{{ message.text }}</span>
                                    </div>
                                </div>


                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-lg-2 col-md-2 col-xs-6">
                <div class="footer-menu">
                    <h3 class="mb-4">{{'footer.auctions' | translate}}</h3>
                    <ul>
                        <li><a routerLink="/contact-us">{{'footer.contact' | translate}}</a></li>
                        <li><a routerLink="/pricing">{{'footer.pricing' | translate}}</a></li>
                        <li><a routerLink="/auctions">{{'footer.auction' | translate}}</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-2 col-xs-6">
                <div class="footer-menu">
                    <h3 class="mb-4">{{'footer.explore' | translate}}</h3>
                    <ul>
                        <li><a routerLink="/wp">{{'footer.blogs' | translate}}</a></li>
                        <li><a routerLink="/faq">{{'footer.faq' | translate}}</a></li>
                        <li><a routerLink="/job-listing">{{'Career.career' | translate}}</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-2 col-xs-6">
                <div class="footer-menu">
                    <h3 class="mb-4">{{'footer.company' | translate}}</h3>
                    <ul>
                        <li><a routerLink="/about-us">{{'footer.about' | translate}}</a></li>
                        <li><a routerLink="/terms-and-conditions">{{'footer.terms-&-conditions' | translate}}</a></li>
                        <li><a routerLink="/privacy-policy">{{'footer.privacy-policy' | translate}}</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class=" underline-row mt-5 text-center">
            <p style="margin-bottom: 0px;">{{'footer.copyright' | translate}} &copy;2010-{{currentYear}}{{'footer.copyright-desc' |
                translate}}</p>
        </div>
        <div class="row social-button mt-4">
            <div class="col-lg-12 d-flex justify-content-center" style="max-width: 670px;">
                <div class="social-box mt-4">
                    <a href="https://www.facebook.com/alqaryahcarsauction" target="_blank" title="Follow on Facebook"
                        style="display: flex; align-items: center; justify-content: space-around;">
                        <img src="../../../assets/img/facebook.svg" width="25%" alt="">
                        <span class="social-text" style="color: white;">{{'footer.facebook' | translate}}</span>
                    </a>
                </div>
                <div class="social-box mt-4">
                    <a href="https://www.instagram.com/alqaryah_auction/" target="_blank" title="Follow on Instagram"
                        style="display: flex; align-items: center; justify-content: space-around;">
                        <img src="../../../assets/img/instagram-02.svg" width="25%" alt="">
                        <span class="social-text" style="color: white;">{{'footer.instagram' | translate}}</span>
                    </a>
                </div>
                <div class="social-box mt-4">
                    <a href="https://www.linkedin.com/company/alqaryahauction/" target="_blank"
                        title="Follow on LinkedIn"
                        style="display: flex; align-items: center; justify-content: space-around;">
                        <img src="../../../assets/img/linkedin-02.svg" width="25%" alt="">
                        <span class="social-text" style="color: white;">{{'footer.linkedIn' | translate}}</span>
                    </a>
                </div>
                <div class="social-box mt-4">
                    <a href="https://www.youtube.com/@alqaryah_auction" target="_blank" title="Follow on YouTube"
                        style="display: flex; align-items: center; justify-content: space-around;">
                        <img src="../../../assets/img/youtube-02.svg" width="25%" alt="">
                        <span class="social-text" style="color: white;">{{'footer.youtube' | translate}}</span>
                    </a>
                </div>
                <div class="social-box mt-4">
                    <a href="https://www.tiktok.com/@alqaryah_auction" target="_blank" title="Follow on TikTok"
                        style="display: flex; align-items: center; justify-content: space-around;">
                        <img src="../../../assets/img/tiktok-02.svg" width="25%" alt="">
                        <span class="social-text" style="color: white;">{{'footer.tiktok' | translate}}</span>
                    </a>
                </div>
            </div>
        </div>

    </div>
</footer>